namespace Gamification.Administration {
    export class UserColumns {
        static columnsKey = 'Administration.User';
    }
}
